export default [
    {
        path: '*',
        redirect: '/404'
    },
    {
        name: 'login',
        path: '/login/:customer?',
        meta: { layout: 'login' },
        component: () => import('@/views/administracao/autenticacao/Login.vue'),
    },
    {
        name: 'recuperar-senha',
        path: '/recuperar-senha/:customer',
        meta: { layout: 'login' },
        component: () => import('@/views/administracao/autenticacao/RecuperarSenha.vue'),
    },
    {
        name: 'painel-senha-emissao-senha-externo',
        path: '/painel-senha/emissao-senha/externo/:cliente/:usuario/:senha/:centroCustoId/:lotacaoId',
        meta: { layout: 'empty' },
        component: () => import('@/views/painel-senha/emissao-senha-externo/Form.vue'),
    },
    {
        path: '/403',
        meta: { layout: 'login', title: 'Access Denied', hiddenInMenu: true },
        component: () => import(/* webpackChunkName: 'error-403' */ '@/views/error/Deny.vue')
    },
    {
        path: '/404',
        meta: { layout: 'login', title: 'Not Found', hiddenInMenu: true },
        component: () => import(/* webpackChunkName: 'error-404' */ '@/views/error/NotFound.vue')
    },
    {
        path: '/500',
        meta: { layout: 'login', title: 'Server Error', hiddenInMenu: true },
        component: () => import(/* webpackChunkName: 'error-500' */ '@/views/error/Error.vue')
    },
    {
        path: '/401',
        meta: { layout: 'login', title: 'Unauthorized', hiddenInMenu: true },
        component: () => import(/* webpackChunkName: 'error-401' */ '@/views/error/Unauthorized.vue')
    },
    {
        name: 'portal-divulgacao',
        path: '/portal-divulgacao/:customer?',
        meta: { layout: 'portal' },
        component: () => import('@/views/portal-divulgacao/List.vue'),
    },
    {
        name: 'regulacao-divulgacao',
        path: '/regulacao-divulgacao/:customer?',
        meta: { layout: 'regulacao-divulgacao' },
        component: () => import('@/views/regulacao-divulgacao/List.vue'),
    },
]